import { Model } from 'pinia-orm';
import Announcement from "./Announcement";

export default class AnnouncementTag extends Model {

    static get entity () {
        return 'announcement_tags';
    }

    static fields () {
        return {
            id: this.uid(),
            title: this.attr(null),
            color: this.attr(null),
            created_at: this.attr(null),

            //relationships
            announcement: this.hasOne(Announcement, 'announcement_tags_id'),
        }
    }
}
